import { ReactNode, useEffect } from "react";
import { StyledModal } from "./style";
import { IconImg } from "../../contents/Icons";
import { Util } from "../../util/Util";

/**
 *
 * @param {Object} param
 * @param {string} param.title - 모달창 타이틀 명
 * @param {ReactNode} param.children - 모달창 메인 컨테이너
 * @param {string} param.caption - 모달창 하단 버튼 명
 * @param {function} param.onClick - 모달창 하단 버튼 클릭시 실행 메소드
 * @param {function} param.modalToggle - 모달창 토글 세터
 * @returns
 */
export const Modal = ({ title, children, caption, onClick, modalToggle }) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      Util.handleKeyPress(e, "enter", modalToggle(false));
    };
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  return (
    <StyledModal>
      <div className="modal-container" onClick={() => modalToggle(false)}>
        <div className="modal-wrap" onClick={(e) => e.stopPropagation()}>
          <div className="title-wrap">
            <p className="title">{title}</p>
            <button className="close-btn" onClick={() => modalToggle(false)}>
              <IconImg.Close />
            </button>
          </div>
          <div className="main-wrap">{children}</div>
          <div className="footer-wrap">
            <button
              onClick={() => {
                onClick();
                modalToggle(false);
              }}
            >
              {caption}
            </button>
          </div>
        </div>
      </div>
    </StyledModal>
  );
};
